import type { FaireProductEntity } from "../../entity_types/product";

export const p_gp27qf7p62: FaireProductEntity = {
  token: "p_gp27qf7p62",
  type: "product",
  name: "Matches • Starry Night Van Gogh Wooden Matchboxes",
  brandToken: "b_6zicjtg87q",
  brandName: "Most Amazing",
  imageUrl:
    "https://cdn.faire.com/fastly/24cfe8d62f7a9c78046179f3589d2507a0488e35a0f22c30b47fb37288b151a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/844a23df63029e38221ebf65b8ef3c0981cf5cc0fd8d4ed218519c63f1599b45.jpeg",
    "https://cdn.faire.com/fastly/22d128fae76f5fa74d1728cd3dcc0589e0882e7025b0b47ed1650d20bc2ca12b.jpeg",
    "https://cdn.faire.com/fastly/726d7aef889ef24ca2985b0c63edc76f7ea83908ba04225bc95d7d5a6f97e279.jpeg",
    "https://cdn.faire.com/fastly/776dfea6a9dd9076f2cca312ac61092bd750c0b5e03aafc285fb759ea539ede5.jpeg",
  ],
  priceDollars: 6.24,
  description:
    "• Matches to elevate your home decor. Light your candles and incense with style. \n• These unique hand-crafted wooden matchboxes feature the Van Gogh painting Starry Night on 2 sides with a striker pad.\n• Each box contains 15-18 matches and measures about  2.3”x1.75”x.75”",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:05.471Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
